// Copyright (c) 2020 Comsearch, Inc., All rights reserved

// compares initial and submitted regulatory values for a single segment end
// to determine if a trigger field has been modified and shout trigger
// Callsign Cascade 2.
// This checks to see if these fields were modified:
// asr
// callsign

const compareRegulatoryValues = (initialRegulatoryValues, submitRegulatoryValues) => {
  const oldTriggeredValues = {}

  if (initialRegulatoryValues.asr !== submitRegulatoryValues.asr) {
    oldTriggeredValues.asr = initialRegulatoryValues.asr
  }

  if (initialRegulatoryValues.callSign !== submitRegulatoryValues.callSign) {
    oldTriggeredValues.callSign = initialRegulatoryValues.callSign
  }

  return oldTriggeredValues
}

export default compareRegulatoryValues
